import axios from "axios";

export const facilityValidate = async (
  userId,
  walletAddress,
  facilityCategory,
  subscriptionPlan,
  token,
) => {
  console.log({
    userId,
    walletAddress,
    facilityCategory,
    subscriptionPlan,
    token,
  });
  const config = {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  };
  try {
    const res = await axios.post(
      `${process.env.REACT_APP_API_URL}/web3/v1/validate-plant`,
      {
        userId,
        walletAddress,
        facilityCategory,
        subscriptionPlan,
      },
      config,
    );

    return res;
  } catch (error) {
    console.log("ERROR", error);
  }
};
export const facilityReject = async (reasonForRejection, userId, token) => {
  console.log({
    reasonForRejection,
    userId,
    token,
  });
  const config = {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  };
  try {
    const res = await axios.post(
      `${process.env.REACT_APP_API_URL}/web3/v1/reject-validation`,
      {
        reasonForRejection,
        userId,
      },
      config,
    );

    return res;
  } catch (error) {
    console.log("ERROR", error);
  }
};

export const facilityVerify = async (
  walletAddress,
  facilityCategory,
  subscriptionPlan,

  token,
) => {
  console.log({
    walletAddress,
    facilityCategory,
    subscriptionPlan,

    token,
  });
  const config = {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  };
  try {
    console.log({
      facilityCategory,
      subscriptionPlan,
      walletAddress,
      token,
    });
    const res = await axios.post(
      `${process.env.REACT_APP_API_URL}/web3/v1/verify-and-mint`,
      { walletAddress, facilityCategory, subscriptionPlan },
      config,
    );

    return res;
  } catch (error) {
    console.log("ERROR", error);
    throw error;
  }
};

export const issueCarbonCredit = async (
  walletAddress,
  facilityCategory,
  subscriptionPlan,
  token,
) => {
  console.log({
    walletAddress,
    facilityCategory,
    subscriptionPlan,
    token,
  });
  const config = {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  };
  try {
    const res = await axios.post(
      `${process.env.REACT_APP_API_URL}/web3/v1/issue-carbon-credit`,
      {
        walletAddress,
        facilityCategory,
        subscriptionPlan,
      },
      config,
    );

    return res;
  } catch (error) {
    console.log("ERROR", error);
  }
};
export const SubmitComment = async (comment, token) => {
  const config = {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  };

  try {
    const res = await axios.post(
      "https://api.closecarbon.com/governance/v1/verifier-create-comment",
      {  comment }, // ✅ Send both values in one object
      config, // ✅ Config goes here
    );

    console.log("Response:", res.data);
    return res.data;
  } catch (error) {
    console.error("ERROR:", error.response?.data || error.message);
    throw error;
  }
};
// list c
export const ListComment = async (comment, userId, token) => {
  const config = {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  };

  try {
    const res = await axios.get(
      "https://q9xcu8j14i.execute-api.us-east-1.amazonaws.com/dev/v1/verifier-comment",
      { userId, comment }, // ✅ Send both values in one object
      config, // ✅ Config goes here
    );

    console.log("Response:", res.data);
    return res.data;
  } catch (error) {
    console.error("ERROR:", error.response?.data || error.message);
    throw error;
  }
};

export const getCommentById = async (userId, token) => {
  const config = {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  };

  try {
    const res = await axios.get(
      `https://q9xcu8j14i.execute-api.us-east-1.amazonaws.com/dev/v1/get-verifier-comments?userId=${userId}`,
      config, // ✅ Config goes here
    );
    console.log("Response:", res.data);
    return res.data;
  } catch (error) {
    console.error("ERROR:", error.response?.data || error.message);
    throw error;
  }
};
